<template>
    <div>
        <HeaderBg :img="img" title="مدن التوصيل" />
        <header class="admin_content_header">
            <div class="filter">
            </div>
            <div class="search">
                <input type="text" placeholder="البحث برقم الفرع">
            </div>
            <router-link :to="'/store-admin/cities/Neighborhood/'+ this.$route.params.id + '/add-district/add'"> + إضافة حي </router-link>
            
        </header>

        <div class="main_table">
            <table width="100%">
                <thead>
                    <tr>
                        <th> المدينة</th>
                        <th> اسم الحي</th>
                        <th> المخزن</th>
                        <th></th>
                        <th></th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="district in districts" :key="district.id">
                        <td>{{district.city.name}}</td>
                        <td>{{district.translation[0].name}}</td>
                        <td>PHA-132</td>
                        <td></td>
                        <td></td>
                        
                        <td>
                          
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import HeaderBg from '../../global/HeaderBg/HeaderBg';
export default {
    name: 'Neighborhood',
    components: {HeaderBg},
    data(){
        return{
            img: require('../../../assets/images/locationLarg.png'),
            districts: []
        }
    },
    mounted(){
        this.getDistrict();
    },
    methods:{
        getDistrict(){
            axios.get(`https://app.almujtama.com.sa/admin/district`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Headers': '*',
                    'Authorization': 'Bearer '+ localStorage.getItem('token'),
                },
                params:{
                    ciry_id: this.$route.params.id
                }
            })
            .then((response) => {
                console.log(response.data.data, 'mmmmmm')
                this.districts = response.data.data
                this.loadingRequest = false;
            
            })
            .catch(err => {
                if(Request.statusIsFaield(err)){
                    this.$router.push('/')
                    localStorage.removeItem('token')
                }
            });
        },
    }
}
</script>
<style lang="scss" scoped>
.saveBtn{
    margin-top: 0;
}
</style>